import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const BrowserSidebarAdmin = (props) => {
    const { t } = useTranslation()
    const [open, setOpen] = useState({});
    const toggleSection = (id) => {
        setOpen((prev) => ({ ...prev, [id]: !prev[id] }));
    };
    return (
        <ul className="list-unstyled components ">

            <li id="financialadmin">
                <div>
                    <a href="#" style={{ color: "Gainsboro" }} className="dropdown-toggle" aria-controls="financialsettings" aria-expanded={!!open.financialsettings} onClick={(e) => { e.preventDefault(); toggleSection("financialsettings"); }}>

                        <b>
                            <FontAwesomeIcon icon="fas fa-money-check-alt" />
                        </b>
                        <b className="forsidebar">&nbsp;{t("financialSettings")}</b>
                    </a>
                    <ul className={`collapse list-unstyled ${open.financialsettings ? "show" : ""}`} id="financialsettings">
                        <li>
                            <a href="/admin/bankaccount">

                                <b className="forsidebar">
                                    {t("bankAccounts")}
                                </b>
                            </a>
                        </li>
                        <li>
                            <a href="/admin/packageprice">
                                <b className="forsidebar">
                                    {t("packagesAndPrices")}
                                </b>
                            </a>
                        </li>
                        <li>
                            <a href="/admin/packagelist">
                                <b className="forsidebar">
                                    {t("packagesList")}
                                </b>
                            </a>
                        </li>
                        <li>
                            <a href="/admin/payment">

                                <b className="forsidebar">
                                    {t("paymentRequests&newRegister")}
                                </b>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <br />
            <li id="coupenadmin">
                <div>
                    <a href="#" style={{ color: "Gainsboro" }} className="dropdown-toggle" aria-controls="admincoupensettings" aria-expanded={!!open.admincoupensettings} onClick={(e) => { e.preventDefault(); toggleSection("admincoupensettings"); }}>

                        <b>
                            <FontAwesomeIcon icon="fas fa-money-check-alt" />
                        </b>
                        <b className="forsidebar">&nbsp;{t("coupensettings")}</b>
                    </a>
                    <ul className={`collapse list-unstyled ${open.admincoupensettings ? "show" : ""}`} id="admincoupensettings">
                        <li>
                            <a href="/admin/coupenlist">

                                <b className="forsidebar">
                                    {t("coupenlist")}
                                </b>
                            </a>
                        </li>
                        <li>
                            <a href="/admin/createcoupen">

                                <b className="forsidebar">
                                    {t("createCoupen")}
                                </b>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <br />
            <li id="useradmin">
                <div>
                    <a href="#" style={{ color: "Gainsboro" }} className="dropdown-toggle" aria-controls="individualusersettings" aria-expanded={!!open.individualusersettings} onClick={(e) => { e.preventDefault(); toggleSection("individualusersettings"); }}>

                        <b>
                            <FontAwesomeIcon icon="fas fa-users" />
                        </b>
                        <b className="forsidebar">&nbsp;{t("individualUserSettings")}</b>
                    </a>
                    <ul className={`collapse list-unstyled ${open.individualusersettings ? "show" : ""}`} id="individualusersettings">

                        {/* <li>
                                    <a href="/admin/usertypelist">
                                        <b className="forsidebar">
                                            {t("userTypesList")}
                                        </b>
                                    </a>
                                </li> */}

                        <li>
                            <a href="/admin/userlist">

                                <b className="forsidebar">
                                    {t("userList")}
                                </b>
                            </a>
                        </li>

                    </ul>
                </div>
            </li>
            <br />
            <li id="corporateadmin">
                <div>
                    <a href="#" style={{ color: "Gainsboro" }} className="dropdown-toggle" aria-controls="corporateusersettings" aria-expanded={!!open.corporateusersettings} onClick={(e) => { e.preventDefault(); toggleSection("corporateusersettings"); }}>

                        <b>
                            <FontAwesomeIcon icon="fas fa-users" />
                        </b>
                        <b className="forsidebar">&nbsp;{t("corporateUserSettings")}</b>
                    </a>
                    <ul className={`collapse list-unstyled ${open.corporateusersettings ? "show" : ""}`} id="corporateusersettings">
                        <li>
                            <a href="/admin/corporateuserlist">

                                <b className="forsidebar">
                                    {t("corporateuserList")}
                                </b>
                            </a>
                        </li>


                        <li>
                            <a href="/admin/schoollist">

                                <b className="forsidebar">
                                    {t("schoolList")}
                                </b>
                            </a>
                        </li>
                        <li>
                            <a href="/admin/createschool">

                                <b className="forsidebar">
                                    {t("createSchool")}
                                </b>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <br />
            <li id="admintickets">
                <div>
                    <a href="#" style={{ color: "Gainsboro" }} className="dropdown-toggle" aria-controls="adminticketsettings" aria-expanded={!!open.adminticketsettings} onClick={(e) => { e.preventDefault(); toggleSection("adminticketsettings"); }}>

                        <b>
                            <FontAwesomeIcon icon="fas fa-users" />
                        </b>
                        <b className="forsidebar">&nbsp;{t("tickets")}</b>
                    </a>
                    <ul className={`collapse list-unstyled ${open.adminticketsettings ? "show" : ""}`} id="adminticketsettings">
                        <li>
                            <a href="/admin/searchticket">

                                <b className="forsidebar">
                                    {t("searchticket")}
                                </b>
                            </a>
                        </li>

                    </ul>
                </div>
            </li>
            <br />
            <li id="moderator">
                <div>
                    <a href="#" style={{ color: "Gainsboro" }} className="dropdown-toggle" aria-controls="moderatorsettings" aria-expanded={!!open.moderatorsettings} onClick={(e) => { e.preventDefault(); toggleSection("moderatorsettings"); }}>

                        <b>
                            <FontAwesomeIcon icon="fas fa-users" />
                        </b>
                        <b className="forsidebar">&nbsp;{t("websiteuser")}</b>
                    </a>
                    <ul className={`collapse list-unstyled ${open.moderatorsettings ? "show" : ""}`} id="moderatorsettings">
                        <li>
                            <a href="/admin/createmoderator">

                                <b className="forsidebar">
                                    {t("createmoderator")}
                                </b>
                            </a>
                        </li>
                        <li>
                            <a href="/admin/moderatorlist">

                                <b className="forsidebar">
                                    {t("moderatorlist")}
                                </b>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <br />
            <hr />
            <li id="sectionadmin">
                <div>
                    <a href="#" style={{ color: "Gainsboro" }} className="dropdown-toggle" aria-controls="sectionsettings" aria-expanded={!!open.sectionsettings} onClick={(e) => { e.preventDefault(); toggleSection("sectionsettings"); }}>

                        <b>
                            <FontAwesomeIcon icon="fas fa-university" />
                        </b>
                        <b className="forsidebar">&nbsp;{t('sectionSettings')}</b>
                    </a>
                    <ul className={`collapse list-unstyled ${open.sectionsettings ? "show" : ""}`} id="sectionsettings">
                        <li>
                            <a href="/admin/createsection">
                                <b className="forsidebar">
                                    {t('createSection')}
                                </b>
                            </a>
                        </li>
                        <li>
                            <a href="/admin/sectionlist">
                                <b className="forsidebar">
                                    {t('sectionList')}
                                </b>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <br />
            <li id="courseadmin">
                <div>
                    <a href="#" style={{ color: "Gainsboro" }} className="dropdown-toggle" aria-controls="coursesettings" aria-expanded={!!open.coursesettings} onClick={(e) => { e.preventDefault(); toggleSection("coursesettings"); }}>

                        <b>
                            <FontAwesomeIcon icon="fas fa-university" />
                        </b>
                        <b className="forsidebar">&nbsp;{t('courseSettings')}</b>
                    </a>
                    <ul className={`collapse list-unstyled ${open.coursesettings ? "show" : ""}`} id="coursesettings">
                        <li>
                            <a href="/admin/createcourse">
                                <b className="forsidebar">
                                    {t('createCourse')}
                                </b>
                            </a>
                        </li>
                        <li>
                            <a href="/admin/courselist">
                                <b className="forsidebar">
                                    {t('courseList')}
                                </b>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <br />
            <li id="subjectadmin">
                <div>
                    <a href="#" style={{ color: "Gainsboro" }} className="dropdown-toggle" aria-controls="subjectsettings" aria-expanded={!!open.subjectsettings} onClick={(e) => { e.preventDefault(); toggleSection("subjectsettings"); }}>

                        <b>
                            <FontAwesomeIcon icon="fas fa-paperclip" />
                        </b>

                        <b className="forsidebar">&nbsp;{t("subjectSettings")}</b>

                    </a>
                    <ul className={`collapse list-unstyled ${open.subjectsettings ? "show" : ""}`} id="subjectsettings">
                        <li>
                            <a href="/admin/createsubject">

                                <b className="forsidebar">
                                    {t("createSubject")}
                                </b>
                            </a>
                        </li>
                        <li>
                            <a href="/admin/subjectlist">

                                <b className="forsidebar">
                                    {t("subjectList")}
                                </b>
                            </a>
                        </li>

                    </ul>
                </div>
            </li>
            <br />
            <li id="questionadmin">
                <div>
                    <a href="#" style={{ color: "Gainsboro" }} className="dropdown-toggle" aria-controls="questionsettings" aria-expanded={!!open.questionsettings} onClick={(e) => { e.preventDefault(); toggleSection("questionsettings"); }}>

                        <b>
                            <FontAwesomeIcon icon="fas fa-question" />                                    </b>

                        <b className="forsidebar">&nbsp;{t("questionSettings")}</b>

                    </a>
                    <ul className={`collapse list-unstyled ${open.questionsettings ? "show" : ""}`} id="questionsettings">
                        <li>
                            <a href="/admin/createquestion">

                                <b className="forsidebar">
                                    {t("createQuestion")}
                                </b>
                            </a>
                        </li>
                        <li>
                            <a href="/admin/questionlist">

                                <b className="forsidebar">
                                    {t("questionList")}
                                </b>
                            </a>
                        </li>

                    </ul>
                </div>
            </li>
            <br />
            <li id="tagadmin">
                <div>
                    <a href="#" style={{ color: "Gainsboro" }} className="dropdown-toggle" aria-controls="tagsettings" aria-expanded={!!open.tagsettings} onClick={(e) => { e.preventDefault(); toggleSection("tagsettings"); }}>

                        <b>
                            <FontAwesomeIcon icon="fas fa-question" />                                    </b>

                        <b className="forsidebar">&nbsp;{t("tagSettings")}</b>

                    </a>
                    <ul className={`collapse list-unstyled ${open.tagsettings ? "show" : ""}`} id="tagsettings">
                        <li>
                            <a href="/admin/createtag">
                                <b className="forsidebar">
                                    {t("createTag")}
                                </b>
                            </a>
                        </li>
                        <li>
                            <a href="/admin/taglist">

                                <b className="forsidebar">
                                    {t("tagList")}
                                </b>
                            </a>
                        </li>

                    </ul>
                </div>
            </li>
            <br />
        </ul>
    );
};

export default BrowserSidebarAdmin;
